import { render } from "./showTemplateProposalComponent.vue?vue&type=template&id=39992e04"
import script from "./showTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./showTemplateProposalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__